import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show d-block currency-modal",
  tabindex: "-1",
  "aria-modal": "true",
  role: "dialog"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content border-0 shadow-lg rounded-4" }
const _hoisted_4 = { class: "modal-header border-bottom-dashed" }
const _hoisted_5 = { class: "modal-chip" }
const _hoisted_6 = { class: "modal-title fw-bold mt-3 mb-1" }
const _hoisted_7 = { class: "text-muted mb-0" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "modal-body p-4 p-xl-40" }
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "field-header" }
const _hoisted_13 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_14 = { class: "field-caption" }
const _hoisted_15 = ["value", "placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "field-header" }
const _hoisted_19 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_20 = { class: "field-caption" }
const _hoisted_21 = ["value", "placeholder"]
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "field-header" }
const _hoisted_25 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_26 = { class: "field-caption" }
const _hoisted_27 = ["value", "placeholder"]
const _hoisted_28 = { class: "col-md-8" }
const _hoisted_29 = { class: "field-header" }
const _hoisted_30 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_31 = { class: "field-caption" }
const _hoisted_32 = ["value", "placeholder"]
const _hoisted_33 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_34 = { class: "d-flex justify-content-between align-items-center mt-4 pt-2" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.isEdit ? _ctx.$t("currency_page.edit_chip") : _ctx.$t("currency_page.new_chip")), 1),
                _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.isEdit ? _ctx.$t("currency_page.update_title") : _ctx.$t("currency_page.create_title")), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("currency_page.modal_description")), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close shadow-none",
                "aria-label": _ctx.$t('common.close'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("currency_page.code")), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("currency_page.code_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.code,
                    type: "text",
                    maxlength: "10",
                    class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.errors.code }]),
                    placeholder: _ctx.$t('currency_page.code_placeholder'),
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-field', 'code', ($event.target as HTMLInputElement).value.toUpperCase())))
                  }, null, 42, _hoisted_15),
                  (_ctx.errors.code)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.errors.code[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("currency_page.name")), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("currency_page.name_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.name,
                    type: "text",
                    class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.errors.name }]),
                    placeholder: _ctx.$t('currency_page.name_placeholder'),
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update-field', 'name', ($event.target as HTMLInputElement).value)))
                  }, null, 42, _hoisted_21),
                  (_ctx.errors.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.errors.name[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("currency_page.symbol")), 1),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("currency_page.symbol_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.symbol,
                    type: "text",
                    maxlength: "5",
                    class: "form-control modal-input",
                    placeholder: _ctx.$t('currency_page.symbol_placeholder'),
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update-field', 'symbol', ($event.target as HTMLInputElement).value)))
                  }, null, 40, _hoisted_27)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("currency_page.rate")), 1),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("currency_page.rate_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.rate,
                    type: "number",
                    step: "0.000001",
                    min: "0",
                    class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.errors.rate }]),
                    placeholder: _ctx.$t('currency_page.rate_placeholder'),
                    onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update-field', 'rate', ($event.target as HTMLInputElement).value)))
                  }, null, 42, _hoisted_32),
                  (_ctx.errors.rate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.errors.rate[0]), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light px-4",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
                }, _toDisplayString(_ctx.$t("common.cancel")), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn style-one px-4 h-55",
                  disabled: _ctx.loading,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('save')))
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.$t("currency_page.saving") : _ctx.isEdit ? _ctx.$t("currency_page.update_action") : _ctx.$t("currency_page.create_action")), 1)
                ], 8, _hoisted_35)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}